<div class="preview-content">
  <div class="container">
    <h2 class="preview-title">{{ 'fgbcl.preview.title' | translate }}</h2>
    <div class="preview-subtitle">{{ 'fgbcl.preview.subtitle' | translate }}</div>
  </div>
  <fgbcl-preview-reward />
  <fgbcl-preview-scorecard />
</div>
